import { ReactElement } from 'react';
import styled from "styled-components";
import { useTranslation } from 'react-i18next';

type ConsentBlock =
  | { type: 'title' | 'subtitle' | 'text' | 'bold'; text: string }
  | { type: 'list'; items: string[] };

// Information documents, in display order: 11-17, 18-24, parents of 11-17.
const CONSENT_DOCUMENTS = [
  'consent_document_minor',
  'consent_document_adult',
  'consent_document_parent',
];

const ConsentScroll = (): ReactElement => {
  const { t, i18n } = useTranslation();

  // Languages without a translation of the documents fall back to French.
  const getBlocks = (key: string): ConsentBlock[] =>
    t(key, {
      returnObjects: true,
      lng: i18n.exists(key) ? i18n.language : 'fr',
    }) as unknown as ConsentBlock[];

  const renderBlock = (block: ConsentBlock, index: number): ReactElement => {
    switch (block.type) {
      case 'title':
        return <Title key={index}>{block.text}</Title>;
      case 'subtitle':
        return <SubTitle key={index}>{block.text}</SubTitle>;
      case 'bold':
        return <Text key={index} style={{ fontWeight: 'bold' }}>{block.text}</Text>;
      case 'list':
        return (
          <ul key={index}>
            {block.items.map((item, itemIndex) => <li key={itemIndex}>{item}</li>)}
          </ul>
        );
      default:
        return <Text key={index}>{block.text}</Text>;
    }
  };

  return (
    <ScrollText>
      {CONSENT_DOCUMENTS.map((key) => (
        <ConsentDocument key={key}>
          {getBlocks(key).map(renderBlock)}
        </ConsentDocument>
      ))}
    </ScrollText>
  );
};

const ScrollText = styled.div`
  height: 300px; // Vous pouvez ajuster la hauteur selon vos besoins
  overflow-y: auto;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
`

const ConsentDocument = styled.div`
  & + & {
    margin-top: 20px;
    padding-top: 10px;
    border-top: 1px solid #ccc;
  }
`

const Title = styled.div`
  font-weight: bold;
  font-size: 18px;
  margin: 10px 5px;
  text-align: center;
  color: black;
`;

const SubTitle = styled.div`
  font-weight: bold;
  font-size: 18px;
  margin: 10px 10px 10px 5px;
  display: flex;
  color: black;
`;

const Text = styled.p`
`

export default ConsentScroll;
